import React, { Component } from 'react';
import * as styles from '../../styles';
import ServicesTableRow from './ServicesTableRow';

const getRowOrder = target => {
  if (target && target[0] && target[0]['category'] && target[0]['category']['order']) {
    return Number(target[0]['category']['order']);
  }
  return 0;
};

class InvoiceTable extends Component {
  constructor() {
    super();
    this.state = {
      filter: '',
      scrollWidth: 15,
    };
    this.tbody;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { filter, scrollWidth } = this.state;
    return JSON.stringify(nextProps) !== JSON.stringify(this.props) ||
      filter !== nextState.filter || scrollWidth !== nextState.scrollWidth;
  }

  render() {
    const { i18n, list, addActiveService, removeActiveService, activeServicesList } = this.props;
    const { scrollWidth } = this.state;
    const filterByInvoice = list.filter(item =>
      item.name.toLowerCase().includes(this.state.filter.toLowerCase())
    );

    const groupByCategories = filterByInvoice.reduce((state, item) => {
      if (state[item.category.name]) {
        state[item.category.name].push(item);
      } else {
        state[item.category.name] = [item];
      }
      return state;
    }, {});

    const categories = Object.keys(groupByCategories).sort(
      (a, b) => getRowOrder(groupByCategories[a]) - getRowOrder(groupByCategories[b])
    );

    return (
      <styles.Table>
        <thead>
          <styles.Row>
            <styles.CellTH colSpan={5} scrollWidth={scrollWidth}>
              <span>{i18n.t('item_name')}</span>
              <span >{i18n.t('nomenclature_number')}</span>
              <span >{i18n.t('price')}</span>
              <span />
            </styles.CellTH>
          </styles.Row>
        </thead>

        <tbody ref={el => {
          this.setState({ scrollWidth: el && el.offsetWidth - el.scrollWidth });
        }}>
          {categories.map(category => (
            <React.Fragment key={category}>
              <styles.Row className="caption-section">
                <td colSpan="5">{category}</td>
              </styles.Row>
              {groupByCategories[category]
                .sort(function (a, b) {
                  if (a.name < b.name) return -1;
                  if (a.name > b.name) return 1;
                  return 0;
                })
                .map(item => (
                  <ServicesTableRow
                    key={item.id}
                    item={item}
                    activeServicesList={activeServicesList}
                    addActiveService={addActiveService}
                    removeActiveService={removeActiveService}
                  />
                ))}
            </React.Fragment>
          ))}
        </tbody>

        <tfoot>
          <tr>
            <td>
              <styles.SearchBlock>
                <styles.SearchInput
                  onChange={e => {
                    this.setState({ filter: e.target.value });
                  }}
                  placeholder={i18n.t('search_placeholder')}
                />
                <styles.SearchIcon />
              </styles.SearchBlock>
            </td>
          </tr>
        </tfoot>
      </styles.Table>

    );
  }
}

export default InvoiceTable;
